import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import
  ResetPasswordConnectErrorBoundary
  from '../components/ResetPasswordConnectErrorBoundary/ResetPasswordConnectErrorBoundary';

// Set a `basename` to be used by the Router/
const basename = process.env.NODE_ENV === 'production' ? '/login' : '/';

//LoadableComponent uses the legacy contextTypes API which will be removed, replaced with lazy and Suspense
const ErrorBar = lazy(() => import('./ErrorBar/ErrorBar'));

const LoginFormComponent = lazy(() => import('../components/LoginForm/LoginForm'));
const LoginForm = () =>
  <Suspense fallback={<div>Loading...</div>}>
    <LoginFormComponent errorBar={ErrorBar} />
  </Suspense>;

const LogoutComponent = lazy(() => import('./Logout/Logout'));
const Logout = () =>
  <Suspense fallback={<div>Loading...</div>}>
    <LogoutComponent errorBar={ErrorBar} />
  </Suspense>;

const ResetPasswordConnectorComponent = lazy(() =>
  import('../components/ResetPasswordConnector/ResetPasswordConnector'));
const ResetPasswordConnector = () =>
  <Suspense fallback={<div>Loading...</div>}>
    <ResetPasswordConnectErrorBoundary>
      <ResetPasswordConnectorComponent errorBar={ErrorBar} />
    </ResetPasswordConnectErrorBoundary>
  </Suspense>;

const ForgotPasswordFormComponent = lazy(() =>
  import('../components/ForgotPasswordForm/ForgotPasswordForm'));
const ForgotPasswordForm = () =>
  <Suspense fallback={<div>Loading...</div>}>
    <ForgotPasswordFormComponent errorBar={ErrorBar} />
  </Suspense>;

const AllRoutes = () => (
  <Router
    basename={basename}
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Routes>
      <Route exact path="/:archive?" element={<LoginForm />}/>
      <Route exact path="/logout" element={<Logout />} />
      <Route exact path="/forgot-password" element={<ForgotPasswordForm />} />
      <Route exact path="/reset-password" element={<ResetPasswordConnector />} />
    </Routes>
  </Router>
);

const Main = () => (
  <AllRoutes />
);

export default Main;
